const sv = {
    "Login": "Logga in",
    "Log out": "Logga ut",
    "Home": "Hem",
    "Clients": "Kunder",
    "Organisations": "Organisationer",
    "Preferences": "Inställningar",
    "Help": "Hjälp",
    "Welcome to the Rolf Administration interface.": "Välkommen till Rolfs Administrationsgränssnitt.",
    "Administration": "AdministrationSV",
    "Here you can manage your clients, organisations, members and administrators.": "Här kan du hantera dina kunder, organisationer, medlemmar och administratörer.",
    "Clients you represent": "Kunder du representerar",
    "List of clients": "Lista över kunder",
    "Here you see a list of clients that you are connected to. Click a client's name to manage it.": "Här ser du en lista över kunder som du är ansluten till. Klicka på en klients namn för att hantera den.",
    "Client": "Kund",
    "Administrators": "Administratörer",
    "List of organisations": "Lista över organisationer",
    "Here you can change the account settings to your Rolf-Administration account, such as changing your name, email and password.": "Här kan du ändra kontoinställningarna för ditt Rolf-Administrationskonto, till exempel ändra ditt namn, e-post och lösenord.",
    "User settings": "Användarinställningar",
    "Change password": "Byt lösenord",
    "First name": "Förnamn",
    "Last name": "Efternamn",
    "E-mail": "E-post",
    "Email": "E-post",
    "Save user settings": "Spara användarinställningar",
    "The email address you enter here is used to log in to Rolf Administration and is also used to reset your password.": "E-postadressen du anger här används för att logga in på Rolf Administration och används också för att återställa ditt lösenord.",
    "Current password": "Nuvarande lösenord",
    "New password": "Nytt lösenord",
    "Repeat new password": "Upprepa nytt lösenord",
    "Password must be at least 10 characters long and cannot be the same as your current password.": "Lösenordet måste vara minst 10 tecken långt och får inte vara samma som ditt nuvarande lösenord.",
    "Password must not be the same as your username/email or other personal information.": "Lösenordet får inte vara samma som ditt användarnamn/e-postadress eller annan personlig information.",
    "Here you can find help on how to use the Rolf-Administration system.": "Här kan du hitta hjälp om hur du använder Rolf-Administrationsystemet.",
    "Contact support": "Kontakta support",
    "Submit a question to support": "Skicka en fråga till support",
    "Send message": "Skicka meddelande",
    "Or contact us by email": "Eller kontakta oss via e-post",
    "Help documents": "Hjälpdokument",
    "Search client": "Sök klient",
    "Search client by name": "Sök klient efter namn",
    "Paying clients": "Betalande kunder",
    "Non-paying clients": "Icke-betalande kunder",
    "Active clients": "Aktiva kunder",
    "Inactive clients": "Inaktiva kunder",
    "Paying": "Betalande",
    "Active": "Aktiv",
    "Modules": "Moduler",
    "Members": "Medlemmar",
    "Create a new client": "Skapa en ny klient",
    "Client name": "Kundnamn",
    "Name of the client": "Kundens namn",
    "Create client": "Skapa klient",
    "Please contact Rolf Nordic AB if you want to change the modules you have access to.": "Kontakta Rolf Nordic AB om du vill ändra de moduler du har tillgång till.",
    "Add organisations": "Lägg till organisation",
    "Parent organisation": "Föräldraorganisation",
    "None": "Ingen",
    "Name": "Namn",
    "Add organisation": "Lägg till organisation",
    "Parent organisation: The organisation you add becomes a suborganisation of the selected organisation": "Föräldraorganisation: Organisationen du lägger till blir en underorganisation till den valda organisationen",
    "Name: This will be the name of the organisation you are adding": "Namn: Detta blir namnet på organisationen du lägger till",
    "Organisation tree": "Organisationsträd",
    "Please contact": "Kontakta",
    "if you need to add or remove administrators.": "om du behöver lägga till eller ta bort administratörer.",
    "Last login": "Senaste inloggning",
    "Password set": "Lösenord satt",
    "Search members": "Sök medlemmar",
    "Search members by name, email or organisation": "Sök medlemmar efter namn, e-post eller organisation",
    "Show only members with \"Owner\" permission": "Visa endast gruppledare",
    "Actions": "Åtgärder",
    "Inactivate": "Inaktivera",
    "Activate": "Aktivera",
    "Generate and send password for": "Generera och skicka lösenord för",
    "Overview": "Översikt",
    "Members & Permissions": "Medlemmar & Behörigheter",
    "Rolfing templates": "Rolfingmallar",
    "Development templates": "Utvecklingsmallar",
    "Pulse templates": "Pulsmallar",
    "Pulse surveys": "Pulsmätningar",
    "Statistics": "Statistik",
    "Settings": "Inställningar",
    "Type": "Typ",
    "Description": "Beskrivning",
    "Delete organisation": "Ta bort organisation",
    "Add sub-organisation": "Lägg till underorganisation",
    "Delete": "Ta bort",
    "Submit": "Skicka",
    "Organisations cannot be deleted if it has sub-organisations, if it has members or has Rolfing Templates that are being used.": "Organisationer kan inte tas bort om den har underorganisationer, om den har medlemmar eller har Rolfing-mallar som används.",
    "* If reflections visibility set to Owners, only owners are selectable when members chose who can read their reflection.": "* Om reflektionssynlighet är inställd på Gruppledare, är endast gruppledare valbara när medlemmar väljer vem som kan läsa deras reflektion.",
    "Reflection visibility *": "Reflektionssynlighet *",
    "All": "Alla",
    "Owners": "Gruppledare",
    "Template name": "Mallnamn",
    "Username / E-mail": "E-post",
    "Enter username or e-mail": "Ange e-post",
    "Password": "Lösenord",
    "Enter password": "Ange lösenord",
    "Log in": "Logga in",
    "Have you forgotten your password?": "Har du glömt ditt lösenord?",
    "Press here": "Tryck här",
    "Request password reset": "Begär lösenordsåterställning",
    "E-mail:": "E-post:",
    "Enter e-mail": "Ange e-post",
    "Back to login": "Tillbaka till inloggning",
    "Security code": "Säkerhetskod",
    "Enter 6 digit security code": "Ange 6-siffrig säkerhetskod",
    "Cancel": "Avbryt",
    "Search clients by name": "Sök efter företagsnamn",
    "Instructions Rolf Administration (Pdf)": "Instruktioner Rolf Administration (Pdf)",
    "Reflection": "Reflektion",
    "Development": "Utvecklingsplan",
    "Development plan": "Utvecklingsplan",
    "Rolfing": "Rolfing",
    "Action plan": "Målplan",
    "Pulse": "Pulsmätning",
    "Parent organisation:": "Föräldraorganisation:",
    "The organisation you add becomes a suborganisation of the selected organisation": "Organisationen du lägger till blir en underorganisation till den valda organisationen",
    "Name:": "Namn:",
    "This will be the name of the organisation you are adding": "Detta blir namnet på organisationen du lägger till",
    "Name of sub-organisation": "Namn på underorganisation",
    "Permissions": "Behörigheter",
    "Default": "Standard",
    "Owner": "Gruppledare",
    "View": "Visa",
    "Edit": "Redigera",
    "Add existing members": "Lägg till befintliga medlemmar",
    "Add new member": "Lägg till ny medlem",
    "Hold CTRL (COMMAND on Mac/OSX) to select multiple users": "Håll ned CTRL (COMMAND på Mac/OSX) för att välja flera användare",
    "Add members": "Lägg till medlemmar",
    "Select members to add to organisation": "Välj medlemmar att lägga till i organisationen",
    "Remove": "Ta bort",
    "Organisation created": "Organisation skapad",
    "Usage statistics": "Användningsstatistik",
    "Reflection trend": "Reflektionstrend",
    "Include sub-organisations": "Inkludera underorganisationer",
    "Month": "Månad",
    "Rolfings": "Rolfingar",
    "Self rolfings": "Själv-rolfingar",
    "Notes": "Noteringar",
    "Activities": "Aktiviteter",
    "Reflection logs": "Reflektionsloggar",
    "Yes": "Ja",
    "No": "Nej",
    "Preferred language": "Föredraget språk",
    "Swedish": "Svenska",
    "English": "Engelska",
    "Generate and send password": "Generera och skicka lösenord",
    "Send welcome email": "Skicka välkomstmejl",
    "Check to generate and send password to users email": "Kryssa i för att generera och skicka lösenord till användaren",
    "Check to send welcome email to user": "Kryssa i för att skicka välkomstmejl till användaren",
    "The email address entered here is used to log in to Rolf.": "E-postadressen du anger här används för att logga in på Rolf.",
    "Core member of team (reflections, rolfings etc is part of organisation)": "Kärnmedlem i team (reflektioner, rolfingar etc är en del av organisationen)",
    "Has access to all team members (can add activities, edit development plan etc)": "Har tillgång till alla gruppmedlemmar (kan lägga till aktiviteter, redigera utvecklingsplan etc)",
    "View member data (rolfings, development plan, activities etc)": "Visa medlemsdata (rolfingar, utvecklingsplan, aktiviteter etc)",
    "Edit member data (perform rolfings, edit development plan, goals etc)": "Redigera medlemsdata (utför rolfingar, redigera utvecklingsplan, mål etc)",
    "Can view aggregated statistics (tagcloud, rolfings, development plan)": "Kan se aggregerad statistik (taggmoln, rolfingar, utvecklingsplan)",
    "Statistic": "Statistik",
    "Loading...": "Laddar...",
    "User activity": "Användaraktivitet",
    "Here you can see the share of active users compared to total users. Active users are users that have been active in Rolf during the month.": "Här kan du se andelen aktiva användare jämfört med totalt antal användare. Aktiva användare är användare som har varit aktiva i Rolf under månaden.",
    "Note: No user activity data is available from before week 13 2024": "Obs: Ingen användaraktivitetsdata är tillgänglig från innan vecka 13 2024",
    "Only paying and active clients can view the user activity data.": "Endast betalande och aktiva kunder kan se användaraktivitetsdata.",
    "From date:": "Från datum:",
    "To date:": "Till datum:",
    "Select dates": "Välj datum",
    "Select time period": "Välj tidsperiod",
    "Active users (%)": "Aktiva användare (%)",
    "Week": "Vecka",
    "Active users": "Aktiva användare",
    "Total users": "Totalt antal användare",
    "Are you sure you want to inactivate the selected members?": "Är du säker på att du vill inaktivera de valda medlemmarna?",
    "Successfully inactivated selected members.": "Inaktiveringen av medlemmarna lyckades",
    "Are you sure you want to activate the selected members?": "Är du säker på att du vill aktivera de valda medlemmarna?",
    "Successfully activated selected members.": "Aktiveringen av medlemmarna lyckades",
    "Are you sure you want to reset the password of the selected members?": "Är du säker på att du vill återställa lösenordet för de valda medlemmarna?",
    "Successfully reset passwords for selected members.": "Lösenordsåterställningen lyckades.",
    "Are you sure you want to add the selected members to the organisation?": "Är du säker på att du vill lägga till de valda medlemmarna i organisationen?",
    "Successfully added selected members to organisation.": "De valda medlemmarna har lagts till i organisationen.",
    "Are you sure you want to remove the selected members from the organisation?": "Är du säker på att du vill ta bort de valda medlemmarna från organisationen?",
    "Successfully removed members from organisation": "Medlemmarna har tagits bort från organisationen",
    "Failed to remove the following members from the organisation:": "Det gick inte att ta bort följande medlemmar från organisationen:",
    "Never": "Aldrig",
    "Click headers to toggle sort order": "Klicka på rubrikerna för att växla sortering",
    "members": "medlemmar",
    "Perform action": "Utför åtgärd",
    "An inactive user can't sign in to Rolf, but an owner can still manage the user": "En inaktiv användare kan inte logga in i Rolf, men kan fortfarande hanteras av gruppledare",
    "An active user can log in to and use Rolf": "En aktiv användare kan logga in och använda Rolf",
    "If you generate a new password, the user will receive an email with a temporary, random, password and the user will no longer be able to log in with their old password.": "Om du genererar ett nytt lösenord kommer användaren att få ett e-postmeddelande med ett tillfälligt, slumpmässigt lösenord och användaren kommer inte längre att kunna logga in med sitt gamla lösenord.",
    "Connect": "Anslut",
    "members to chosen organisation": "medlemmar till vald organisation",
    "Set permissions for members": "Ange behörigheter för medlemmar",
    "What do the permissions mean?": "Vad betyder behörigheterna?",
    "Send welcome email to": "Skicka välkomstmejl till",
    "The welcome email will be sent in the language selected as \"Preferred language\" for each member": "Välkomstmejlet skickas på det språk som valts som \"Föredraget språk\" för varje medlem",
    "How do I add new members?": "Hur lägger jag till nya medlemmar?",
    "A member is connected to one or more specific organisations. To add a new member:": "En medlem är ansluten till en eller flera specifika organisationer. För att lägga till en ny medlem:",
    "Navigate to \"Organisations\"-tab": "Navigera till \"Organisationer\"-fliken",
    "Select the specific organisation or suborganisation in which you wish to create the new member": "Välj den specifika organisationen eller underorganisationen där du vill skapa den nya medlemmen",
    "Navigate to the \"Members\"-tab": "Navigera till \"Medlemmar\"-fliken",
    "Fill in the required information in the \"Add new member\"-form (name, email etc.)": "Fyll i den nödvändiga informationen i \"Lägg till ny medlem\"-formuläret (namn, e-post etc.)",
    "Press \"Submit\"": "Tryck på \"Skicka\"",
    "Created": "Skapad",
    "Create template": "Skapa mall",
    "Create rolfing template": "Skapa rolfingmall",
    "Create development template": "Skapa utvecklingsmall",
    "Create pulse template": "Skapa pulsmall",
    "Clone existing template": "Klona befintlig mall",
    "Clone template": "Klona mall",
    "You can have a maximum of 10 custom labels, and the last label can not have an end point higher than 10." : "Du kan ha maximalt 10 anpassade etiketter, och den sista etiketten kan inte ha en slutpunkt högre än 10.",
    "You can not have overlapping labels.": "Du kan inte ha överlappande etiketter.",
    "The range must start at 1 and end at 10 points": "Intervallet måste börja på 1 och sluta på 10 poäng",
    "You have no labels. Add a new label.": "Du har inga etiketter. Lägg till en ny etikett.",
    "Rolfing template": "Rolfingmall",
    "Basic settings": "Grundinställningar",
    "Edit the rolfing template here. You can add and remove properties, and change the name and description. You can also customise the scale that is being used.": "Redigera rolfingmallen här. Du kan lägga till och ta bort egenskaper, och ändra namn och beskrivning. Du kan också anpassa skalan som används.",
    "Custom settings": "Anpassade inställningar",
    "Feedback description": "Feedbackbeskrivning",
    "Actions description": "Åtgärdsbeskrivning",
    "Rolfing scale": "Rolfingskala",
    "Custom labels": "Anpassade etiketter",
    "Scale 1-10 (default)": "Skala 1-10 (standard)",
    "Label title": "Etikettitel",
    "Remove this label": "Ta bort etikett",
    "Start point": "Startpoäng",
    "End point": "Slutpoäng",
    "Rolfing Steps": "Rolfingsteg",
    "Property name & sort order": "Namn & sorteringsordning",
    "Property description": "Beskrivning",
    "+ Add rolfing step": "+ Lägg till rolfingsteg",
    "Remove rolfing step": "Ta bort rolfingsteg",
    "Save rolfing template and steps": "Spara rolfingmall och steg",
    "Preview template": "Förhandsgranska mall",
    "This template has been used": "Denna mall har använts",
    "times and can not be deleted.": "gånger och kan inte tas bort.",
    "Development template": "Utvecklingsmall",
    "Edit the development template here. You can add and remove focus areas, and change the name and description.": "Redigera utvecklingsmallen här. Du kan lägga till och ta bort fokusområden, och ändra namn och beskrivning.",
    "Add label": "Lägg till etikett",
    "Add focus area": "Lägg till fokusområde",
    "Delete template": "Ta bort mall",
    "Save development template": "Spara utvecklingsmall",
    "Focus areas": "Fokusområden",
    "Focus area name & sort order": "Fokusområdets namn & sorteringsordning",
    "Focus area description": "Fokusområdets beskrivning",
    "Remove focus area": "Ta bort fokusområde",
    "Here you can see the trend of reflection logs and feedback over time. The chart shows how many percent of the members that have submitted a reflection log, and how many percent of the reflection logs that have received feedback. The chart shows the data week by week and is based on the selected time period.": "Här kan du se trenden för reflektionsloggar och feedback över tid. Diagrammet visar hur många procent av medlemmarna som har skickat in en reflektionslogg, och hur många procent av reflektionsloggarna som har fått feedback. Diagrammet visar data vecka för vecka och är baserat på den valda tidsperioden.",
    "Feedback statistics": "Feedbackstatistik",
    "From:": "Från:",
    "To:": "Till:",
    "Reflection log usage statistics": "Statistik för reflektionsloggar",
    "Reflection percent (%)": "Reflektionsprocent (%)",
    "Pulse survey templates": "Pulsmallar",
    "Rolf Pulse surveys": "Rolf Pulsmätningar",
    "Here you can create and manage pulse surveys. A pulse survey is a short survey that can be sent out to recipients. The recipients answer the survey anonymously and the results are presented in the Rolf App.": "Här kan du skapa och hantera pulsmätningar. En pulsmätning är en kort undersökning som kan skickas ut till mottagare. Mottagarna svarar på undersökningen anonymt och resultaten presenteras i Rolf-appen.",
    "1. Create a pulse survey template": "1. Skapa en pulsmall",
    "2. Create the pulse survey": "2. Skapa pulsmätningen",
    "3. Send out invitations": "3. Skicka ut inbjudningar",
    "4. View results": "4. Visa resultat",
    "Create a pulse survey template": "Skapa en pulsmall",
    "A template contains the questions that the user answers. You can create a template with questions that you can reuse in multiple Pulse surveys.": "En mall innehåller de frågor som användaren svarar på. Du kan skapa en mall med frågor som du kan återanvända i flera pulsmätningar.",
    "A Pulse survey consists of a template (with questions) that can be sent to recipients. Settings such as title, description and survey end date are set here.": "En pulsmätning består av en mall (med frågor) som kan skickas till mottagare. Inställningar som titel, beskrivning och undersökningens slutdatum ställs in här.",
    "When a pulse survey has been created, invitations can be sent out to recipients. You can also send reminders to those who have not yet answered the survey.": "När en pulsmätning har skapats kan inbjudningar skickas ut till mottagare. Du kan också skicka påminnelser till dem som ännu inte har svarat på undersökningen.",
    "When recipients have answered the survey, the results can be viewed in the": "När mottagarna har svarat på undersökningen kan resultaten ses i",
    "The results are presented in a clear and easy-to-understand way.": "Resultaten presenteras på ett tydligt och lättförståeligt sätt.",
    "Rolf App": "Rolf-appen",
    "No templates found": "Inga mallar hittades",
    "Survey name": "Titel",
    "No surveys found": "Inga pulsmätningar hittades",
    "Create new pulse survey": "Skapa ny pulsmätning",
    "Click on the name to manage the survey (edit, delete, send invitations)": "Klicka på namnet för att hantera mätningen (redigera, ta bort, skicka inbjudningar)",
    "Create new Pulse Survey": "Skapa ny pulsmätning",
    "Title": "Titel",
    "This title is visible when the user answers the survey and when the team leader reviews the results.": "Denna titel är synlig när användaren svarar på undersökningen och när gruppledaren granskar resultaten.",
    "Description (email invitation)": "Beskrivning (e-postinbjudan)",
    "This description is included in the invitation email.": "Denna beskrivning ingår i inbjudningsmejlet.",
    "Template (Questions)": "Mall (Frågor)",
    "End date": "Slutdatum",
    "Create survey": "Skapa mätning",
    "The survey will be closed after this date.": "Undersökningen kommer att stängas efter detta datum.",
    "Preview": "Förhandsgranska",
    "The template contains the questions that will be asked in the survey.": "Mallen innehåller de frågor som kommer att ställas i undersökningen.",
    "You must select a template in order to preview it.": "Du måste välja en mall för att förhandsgranska den.",
    "Create a pulse survey": "Skapa en pulsmätning",
    "Pulse survey template": "Pulsmall",
    "Edit the pulse survey template here. You can add and remove questions, and change the title and description. You can also customise the scale that is being used to answer the questions.": "Redigera pulsmallen här. Du kan lägga till och ta bort frågor, och ändra titel och beskrivning. Du kan också anpassa skalan som används för att besvara frågorna.",
    "Free text question description": "Beskrivning av fritextfråga",
    "Response scale": "Svarsskala",
    "Pulse Survey questions": "Pulsmätningens frågor",
    "Question title & sort order": "Frågans titel & sorteringsordning",
    "Question description": "Frågans beskrivning",
    "Remove question": "Ta bort fråga",
    "+ Add question": "+ Lägg till fråga",
    "These settings are optional.": "Dessa inställningar är valfria.",
    "The description you write here will be used as placeholder/help-text in the final \"Free text question\".": "Beskrivningen du skriver här kommer att användas som hjälptext i den slutliga \"Fritextfrågan\".",
    "New & not saved yet!": "Ny & inte sparad än!",
    "You do not have permission to view this page.": "Du har inte behörighet att visa denna sida.",
    "Pulse survey Templates": "Pulsmallar",
    "Template Name": "Mallnamn",
    "A template constitutes the questions that the user answers": "En mall utgör de frågor som användaren svarar på",
    "Create Template": "Skapa mall",
    "The template name is visible when the user answers the surveys that uses the template.": "Mallnamnet är synligt när användaren svarar på undersökningarna som använder mallen.",
    "If a template is not active, it will not be available for use": "Om en mall inte är aktiv kommer den inte att vara tillgänglig för användning",
    "This description is visible when the user answers the survey.": "Denna beskrivning är synlig när användaren svarar på undersökningen.",
    "Create pulse survey template": "Skapa pulsmall",
    "You need to select a client and organisation to clone the template to.": "Du måste välja en klient och organisation att klona mallen till.",
    "Select which client and organisation you want to clone this template to. You can clone templates into all clients and organisations which you, as administrator, has access to.": "Välj vilken klient och organisation du vill klona denna mall till. Du kan klona mallar till alla klienter och organisationer som du, som administratör, har åtkomst till.",
    "Template": "Mall",
    "Current client": "Nuvarande klient",
    "Current organisation": "Nuvarande organisation",
    "The list below shows all": "Listan nedan visar alla",
    "templates in the current organisation.": "mallar i den nuvarande organisationen.",
    "Select template to clone": "Välj mall att klona",
    "First, select a template to clone. In the next step you will select which client and organisation to clone the template to.": "Först väljer du en mall att klona. I nästa steg väljer du vilken klient och organisation du vill klona mallen till.",
    "pulse": "puls",
    "development": "utvecklings",
    "Change template": "Byt mall",
    "Save template and questions": "Spara mall och frågor",
    "Comment (optional)": "Kommentar (valfritt)",
    "Send invitations": "Skicka inbjudningar",
    "Are you sure you want to delete this invite? This cannot be undone!" : "Är du säker på att du vill ta bort denna inbjudan? Detta kan inte ångras!",
    "Invite deleted successfully": "Inbjudan raderades",
    "Could not delete invite": "Kunde inte radera inbjudan",
    "Survey updated": "Mätningen uppdaterad",
    "Could not update survey": "Kunde inte uppdatera mätningen",
    "You cannot change template after invitations has been sent.": "Du kan inte ändra mall efter att inbjudningar har skickats.",
    "Invited": "Inbjudna",
    "Here you can see all the recipients that have been invited to answer the survey.": "Här kan du se alla mottagare som har bjudits in att svara på undersökningen.",
    "Note: If you delete an invite, the recipient will no longer be able to answer the survey. However, invitation emails has already been sent to the recipients above.": "Obs: Om du tar bort en inbjudan kommer mottagaren inte längre att kunna svara på undersökningen. Dock har inbjudningsmejl redan skickats till mottagarna ovan.",
    "Remind those who have not yet answered": "Påminn dem som ännu inte har svarat",
    "Send reminder": "Skicka påminnelse",
    "The survey has ended, you cannot send reminders": "Undersökningen har avslutats, du kan inte skicka påminnelser",
    "Summary": "Sammanfattning",
    "Number of invites sent": "Antal inbjudningar skickade",
    "Number of answers": "Antal svar",
    "Answer percentage": "Svarsprocent",
    "Where are the results of the Pulse Survey?": "Var finns resultaten av pulsmätningen?",
    "You can see the results in the": "Du kan se resultaten i",
    "Check to delete survey": "Kryssa i för att ta bort mätningen",
    "Delete survey": "Ta bort mätning",
    "Note: If you delete a survey, all invites and answers will be deleted. This cannot be undone.": "Obs: Om du tar bort en mätning kommer alla inbjudningar och svar att raderas. Detta kan inte ångras.",
    "Edit Survey": "Redigera mätning",
    "Save pulse survey": "Spara pulsmätning",
    "Send out invitations": "Skicka ut inbjudningar",
    "Here you can send out invitations to recipients. You can add recipients from your organisations.": "Här kan du skicka ut inbjudningar till mottagare. Du kan lägga till mottagare från dina organisationer.",
    "Add Recipients": "Lägg till mottagare",
    "Add recipients from organisations:": "Lägg till mottagare från organisationer:",
    "Add from the selected organisations": "Lägg till från de valda organisationerna",
    "Import from the current organisation:": "Importera från den nuvarande organisationen",
    "Add from the current organisation": "Lägg till från den nuvarande organisationen",
    "Pulse survey:" : "Pulsmätning:",
    "SEND INVITATIONS": "SKICKA INBJUDNINGAR",
    "The survey has ended, you cannot send invitations": "Undersökningen har avslutats, du kan inte skicka inbjudningar",
    "Recipient": "Mottagare",
    "No recipients added yet": "Inga mottagare har lagts till ännu",
    "Could not get members": "Kunde inte hämta medlemmar",
    "member(s) added": "medlemmar tillagda",
    "Next": "Nästa",
    "Back": "Tillbaka",
    "Continue": "Fortsätt",
    "Submit response": "Skicka svar",
    "Rolf Pulse": "Rolf Puls",
    "Welcome to our anonymous survey.": "Välkommen till vår anonyma undersökning.",
    "Your responses are confidential, and no personally identifiable information is being collected.": "Dina svar är konfidentiella, och ingen personligt identifierbar information samlas in.",
    "If you have any questions or concerns about the anonymity of this survey, please feel free to reach out to us at info@rolf.se": "Om du har några frågor eller funderingar om anonymiteten i denna undersökning, är du välkommen att kontakta oss på info@rolf.se.",
    "Finish": "Slutför",
    "Before submitting your responses, you have the opportunity to share your thoughts related to this survey. You can leave the field blank.": "Innan du skickar in dina svar har du möjlighet att delge dina synpynkter kopplade till denna undersökning. Du kan lämna fältet tomt.",
    "When you are satisfied with your responses and want to complete the survey, click \"Submit response\".": "När du är nöjd med dina svar och vill slutföra undersökningen klickar du på \"Skicka svar\".",
    "Other comments you want to share (optional)": "Övriga kommentarer du vill dela med dig av (frivilligt)",
    "Assessment": "Bedömning",
    "Do not use": "Använd inte",
    "Comment": "Kommentar",
    "Search members by name or email": "Sök medlemmar efter namn eller e-post",
    "Modules included in the 'Current Client' row are typically charged to the current client": "Moduler som ingår i raden 'Nuvarande kund' debiteras normalt sett den nuvarande kunden",
    "Modules activated on other clients cannot be modified here. These modules are typically charged to the client where they are activated.": "Moduler som är aktiverade på andra kunder kan inte ändras här. Dessa moduler debiteras normalt sett den kund där de är aktiverade.",
    "Default modules for organisation": "Standardmoduler för organisationen",
    "Save modules": "Spara moduler",
    "Saving modules...": "Sparar moduler...",
    "Modules saved successfully": "Modulerna sparades",
    "Failed to save modules": "Det gick inte att spara modulerna",
    "Total:": "Totalt:",
    "All Clients": "Alla kunder",
    "Current Client": "Nuvarande kund",
    "Select Rolfing template": "Välj Rolfingmall",
    "Feedback percent (%)": "Feedbackprocent (%)",
    "Member permissions updated successfully": "Medlemsbehörigheterna uppdaterades",
    "Member updated successfully": "Medlemmen uppdaterades",
    "Are you sure you wish to remove this member from this organisation?": "Är du säker på att du vill ta bort denna medlem från denna organisation?",
    "Member removed from organisation successfully": "Medlemmen togs bort från organisationen",
    "Member added to organisation successfully": "Medlemmen lades till i organisationen",
    "Are you sure you wish to unregister this member?": "Är du säker på att du vill avregistrera denna medlem?",
    "Member unregistered successfully": "Medlemmen avregistrerades",
    "Password generated successfully": "Lösenordet genererades",
    "Modules saved successfully": "Modulerna sparades",
    "Welcome email sent successfully": "Välkomstmejlet skickades",
    "Could not send welcome email": "Kunde inte skicka välkomstmejlet",
    "Limited access": "Begränsad åtkomst",
    "please contact": "vänligen kontakta",
    "if you need to change this members settings.": "om du behöver ändra denna medlems inställningar.",
    "Last logged in": "Senast inloggad",
    "Settings": "Inställningar",
    "Default:": "Standard:",
    "Owner:": "Gruppledare:",
    "View:": "Visa:",
    "Edit:": "Redigera:",
    "Statistics:": "Statistik:",
    "Phone number": "Telefonnummer",
    "Generate password": "Generera lösenord",
    "NOTE! This will override users current password": "OBS! Detta kommer att åsidosätta användarens nuvarande lösenord",
    "This will generate a new password and send it to the users email address. User should change his/her password upon login.": "Detta kommer att generera ett nytt lösenord och skicka det till användarens e-postadress. Användaren bör ändra sitt lösenord vid inloggning.",
    "Send Welcome email": "Skicka välkomstmejl",
    "Check to send a new welcome email to this user": "Kryssa i för att skicka ett nytt välkomstmejl till denna användare",
    "Send email": "Skicka mejl",
    "Organisation permissions": "Organisationsbehörigheter",
    "Set permission": "Ange behörighet",
    "Add to org.": "Lägg till i org.",
    "Unregister": "Avregistrera",
    "Unregistering a member will remove all permissions and access to Rolf.": "Avregistrering av en medlem kommer att ta bort alla behörigheter och åtkomst till Rolf.",
    "This cannot be undone!": "Detta kan inte ångras!",
    "Check to unregister": "Kryssa i för att avregistrera",
    "Payments & Billing": "Betalning & Fakturering",
    "My Clients": "Mina kunder",
    "Connected administrators": "Anslutna administratörer",
    "Billing overview": "Faktureringsöversikt",
    "Here you can see all invoices on all your clients, and their status.": "Här kan du se alla fakturor på alla dina kunder, och deras status.",
    "Send commission invoices to Rolf Nordic AB, org. number: 556962-6046. Invoice is sent by email to:": "Skicka provisionsfakturor till Rolf Nordic AB, org. nummer: 556962-6046. Fakturan skickas via e-post till:",
    "Date Filter": "Datumfilter",
    "Customer": "Kund",
    "Invoice date": "Fakturadatum",
    "Value": "Värde",
    "Partner": "Partner",
    "Commission (%)": "Provision (%)",
    "Commission (sek)": "Provision (sek)",
    "Customer invoice paid": "Kundfaktura betald",
    "Commission invoiced": "Provision fakturerad",
    "Commission paid": "Provision betald",
    "Outstanding commission": "Utestående provision",
    "Total outstanding commission:": "Total utestående provision:",
    "Check \"Commission invoiced\" to mark the commission as invoiced when you have sent your commission invoice to Rolf Nordic AB.": "Kryssa i \"Provision fakturerad\" för att markera provisionen som fakturerad när du har skickat din faktura till Rolf Nordic AB.",
    "Reset date filter": "Återställ datumfilter",
    "Close": "Stäng",
    "Customer invoce paid": "Kundfaktura betald",
    "There can not be any gaps between the labels.": "Det får inte finnas några mellanrum mellan etiketterna.",
    "Cannot save due to errors in the form": "Kan inte spara på grund av fel i formuläret",
    "Comment placeholder text": "Kommentarshjälptext",
    "The description you enter here will be used as placeholder/help-text in the comment field for this question.": "Beskrivningen du skriver här kommer att användas som hjälptext i kommentarsfältet för denna fråga.",
    "Add": "Lägg till",
    "Select a template": "Välj en mall",
    "No invitations sent": "Inga inbjudningar skickade",
    "Delete invite": "Ta bort inbjudan",
    "Include": "Inkludera",
    "All members (default + owner permissions)": "Alla medlemmar (standard + gruppledare)",
    "Default members": "Standardmedlemmar",
    "Owners": "Gruppledare",
    "Reflection (%)": "Reflektion (%)",
    "Feedback (%)": "Feedback (%)",
    "Private reflections (%)": "Privata reflektioner (%)",
    "Feedback percent (%)": "Feedbackprocent (%)",
    "January": "Januari",
    "February": "Februari",
    "March": "Mars",
    "April": "April",
    "May": "Maj",
    "June": "Juni",
    "July": "Juli",
    "August": "Augusti",
    "September": "September",
    "October": "Oktober",
    "November": "November",
    "December": "December",
    "Last logged in": "Senast inloggad:",
    "never": "aldrig",
    "OTP via SMS": "OTP via SMS",
    "Phone number": "Telefonnummer",
    "Submit": "Skicka",
    "Generate password": "Generera lösenord",
    "This will generate a new password and send it to the users email address. User should change his/her password upon login.": "Detta kommer att generera ett nytt lösenord och skicka det till användarens e-postadress. Användaren bör ändra sitt lösenord vid inloggning.",
    "Send Welcome email": "Skicka välkomstmejl",
    "Check to send a new welcome email to this user": "Kryssa i för att skicka ett nytt välkomstmejl till denna användare",
    "Send email": "Skicka e-post",
    "Organisation permissions": "Organisationsbehörigheter",
    "Select organisations": "Välj organisationer",
    "Set permission": "Ange behörighet",
    "Add to org.": "Lägg till i org.",
    "Default:": "Standard:",
    "Owner:": "Gruppledare:",
    "View:": "Visa:",
    "Edit:": "Redigera:",
    "Statistics:": "Statistik:",
    "Unregister": "Avregistrera",
    "Unregistering a member will remove all permissions and access to Rolf.": "Avregistrering av en medlem kommer att ta bort alla behörigheter och åtkomst till Rolf.",
    "This cannot be undone!": "Detta kan inte ångras!",
    "Member permissions updated successfully": "Medlemsbehörigheter uppdaterade",
    "Member updated successfully": "Medlem uppdaterad",
    "Are you sure you wish to remove this member from this organisation?": "Är du säker på att du vill ta bort denna medlem från denna organisation?",
    "Member removed from organisation successfully": "Medlemmen har tagits bort från organisationen",
    "Member added to organisation successfully": "Medlemmen har lagts till i organisationen",
    "Are you sure you wish to unregister this member?": "Är du säker på att du vill avregistrera denna medlem?",
    "Member unregistered successfully": "Medlemmen har avregistrerats",
    "Password generated successfully": "Lösenordet genererades",
    "Welcome email sent successfully": "Välkomstmejlet skickades",
    "Could not send welcome email": "Kunde inte skicka välkomstmejlet",
    "Survey statistics": "Undersökningsstatistik",
    "Here you can see, per organisation, how many invitations have been sent out and how many have been answered.": "Här kan du se, per organisation, hur många inbjudningar som har skickats ut och hur många som har besvarats.",
    "Answered": "Besvarade",
    "Not answered": "Ej besvarade",
    "Invited members:": "Inbjudna medlemmar:",
    "Has answered:": "Har svarat:",
    "Answer percentage:": "Svarsprocent:",
    "Already invited": "Redan inbjudna",
    "Date": "Datum",
    "Invited: ": "Inbjuden: ",
    "Survey changelog": "Undersökningslogg",
    "Administrator": "Administratör",
    "Action": "Åtgärd",
    "Date": "Datum",
    "Survey invites sent": "Inbjudningar skickade",
    "Survey invite deleted": "Inbjudning raderad",
    "Survey reminder sent"  : "Påminnelser skickade",
    "Survey created": "Undersökning skapad",
    " recipient(s) do not have the Pulse module and will not be invited": " mottagare har inte Puls-modulen och kommer inte att bjudas in",
    "Manage": "Hantera",
    "Missing module": "Saknar modul",
    "Also include inactive members": "Inkludera även inaktiva medlemmar",
    "Move template": "Flytta mall",
    "Select which organisation you want to move the template into.": "Välj vilken organisation du vill flytta mallen till.",
    "Select organisation": "Välj organisation",
    "Template moved successfully.": "Mallen flyttades",
    "Template cloned successfully.": "Mallen klonades",
    "Details": "Detaljer",
    "Invoice details": "Fakturadetaljer",
    "Invoice to": "Faktura till",
    "Total value:": "Totalt värde:",
    "Invoice paid:": "Fakturan betald:",
    "Partner name": "Partnernamn",
    "Total Commission": "Total provision",
    "Module": "Modul",
    "Price": "Pris",
    "Nr of modules": "Antal moduler",
    "Sum": "Summa",
    "Implementation fee:": "Implementeringsavgift:",
    "Note: The number of modules is less than the minimum licenses. The invoice value is therefore based on minimum licenses.": "Obs: Antalet moduler är mindre än minimilicenserna. Fakturabeloppet baseras därför på minimilicenserna.",
    "Commission on implementation fee:": "Provision på implementeringsavgift:",
    "Price model": "Prismodell",
    "Minimum licenses": "Minimalt antal licenser",
    "Total modules": "Totalt antal moduler",
    "New price model": "Nya prismodellen",
    "Old price model": "Gamla prismodellen",
    "No partner": "Ingen partner",
    "Select template": "Välj mall",
    "Templates in current organisation": "Mallar i nuvarande organisation",
    "Templates from template library": "Mallar från mallbiblioteket",
    "Clone to template library": "Klona till mallbiblioteket",
    "Note: The billing interval is set to ": "Obs: Faktureringsintervallet är inställt på ",
    " months. The number of modules and the invoice value are therefore multiplied by this factor." : " månader. Antalet moduler och fakturabeloppet multipliceras därför med denna faktor.",
    "+ Add label": "+ Lägg till etikett",
    "Custom groups": "Anpassade grupper",
    "Group name & sort order": "Gruppnamn & sorteringsordning",
    "Group description": "Gruppbeskrivning",
    "Remove group": "Ta bort grupp",
    "+ Add custom group": "+ Lägg till anpassad grupp",
    "Assign to group": "Tilldela till grupp",
    "No group": "Ingen grupp",
    "Customize": "Anpassa",
    "You can create custom groups to organise the rolfing steps. These groups will be shown as separate sections when performing a rolfing.": "Du kan skapa anpassade grupper för att organisera rolfingstegen. Dessa grupper visas som separata avsnitt när du utför en rolfing.",
    " times and is locked for editing.": " gånger och är låst för redigering.",
    "Unlock": "Lås upp",
    "You can create custom groups to organise the pulse survey questions.": "Du kan skapa anpassade grupper för att organisera pulsmätningens frågor.",
    "Are you sure you want to delete this template?": "Är du säker på att du vill ta bort denna mall?",
    "Template saved": "Mallen sparades",
    "Error: Unable to save the template.": "Fel: Kunde inte spara mallen.",


};

export default sv;